import { motion, useScroll, useTransform } from "framer-motion";
import Header from '../component/Header'
import Footer from '../component/Footer'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Achivment from "../component/Achivment";

export default function StructuredFinance() {





    return (
        <div>
            <Header />
            <section className="relative overflow-hidden bg-gradient-to-br from-slate-950 via-blue-950 to-cyan-900  pt-36 pb-10 px-4 sm:px-6 lg:px-8">

                <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-[120px]" />
                <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/20 blur-[140px] rounded-full" />
                <div className="absolute inset-0 opacity-10 bg-[linear-gradient(rgba(255,255,255,.15)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.15)_1px,transparent_1px)] bg-[size:40px_40px]" />

                <div className="max-w-7xl mx-auto relative z-10">
                    {/* Breadcrumb */}
                    <div className="flex items-center  flex-wrap gap-2 text-sm text-white/70 mb-6">Home
                        <KeyboardArrowRightIcon className="w-4 h-4" />
                        <span className="text-cyan-300">
                            Expertise
                        </span>
                    </div>
                    <div className='max-w-6xl'>
                        <h1 className="text-3xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight mb-5">
                            Expertise:{" "}
                            <span className="text-dark-gold"> Structured Finance</span>

                        </h1>

                        {/* Description */}
                        <p className=" text-white/70 text-lg sm:text-base lg:text-2xl leading-relaxed mb-20 ">
                            Tailored financial structuring for complex transactions including securitization, LRD, promoter funding, and special situation financing.
                            Focused on creating innovative capital solutions aligned with business cash flows and project viability.

                        </p>
                    </div>
                </div>
                <div className="max-w-7xl mx-auto relative z-10">
                   
                    {/* Cards */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-5 sm:gap-6">

                        {[
                            {
                                title: "LRD",
                                desc: "Lease Rental Discounting against secured rental cash flows from commercial assets.",
                                color: "from-[#1e3a8a] to-[#0ea5e9]",
                                // icon: aiIcon
                            },
                            {
                                title: "Securitization",
                                desc: "Conversion of receivables or assets into marketable financial instruments for liquidity generation.",
                                color: "from-[#10b981] to-[#059669]",
                                // icon: apiIcon
                            },
                            {
                                title: "Acquisition Finance",
                                desc: "Funding solutions designed for mergers, acquisitions, and strategic buyouts.",
                                color: "from-[#1e3a8a] to-[#0ea5e9]",
                                // icon: devIcon
                            },
                            {
                                title: "Distressed Funding",
                                desc: "Special situation financing for stressed assets, restructuring, and turnaround opportunities.",
                                color: "from-[#1e3a8a] to-[#0ea5e9]",
                                // icon: devIcon
                            },
                        ].map((item, i) => (
                            <div
                                key={i}
                                className="group backdrop-blur-xl bg-white border border-white/90 rounded-xl p-6 sm:p-7 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
                            >
                                {/* Icon */}
                                <div
                                    className="w-14 h-14 sm:w-16 sm:h-16 bg-gr rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition p-3" style={{ background: '#00bd86' }}
                                >
                                    {/* Add icon here */}
                                    {/* <img src={item.icon} alt={item.title} /> */}

                                </div>

                                {/* Title */}
                                <h3 className="text-lg sm:text-xl font-semibold text-white mb-2">
                                    {item.title}
                                </h3>

                                {/* Description */}
                                <p className="text-sm sm:text-base text-slate-400 mb-4 leading-relaxed">
                                    {item.desc}
                                </p>

                                {/* CTA */}
                               
                            </div>
                        ))}

                    </div>
                </div>
            </section>
           
            <Achivment />
            <Footer />
        </div>
    )
}



